'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherAmountComponent = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _components = require('../../components');

var _common = require('../../utils/common');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OtherAmountComponent = exports.OtherAmountComponent = function OtherAmountComponent(props) {
  var _React$useState = _react2.default.useState(false),
      _React$useState2 = (0, _slicedToArray3.default)(_React$useState, 2),
      showAmountfield = _React$useState2[0],
      setShowAmountField = _React$useState2[1];

  var updateAmount = function updateAmount(event) {
    if (event && event.target) {
      setTimeout(function () {
        return props.change(_constants.QD_RF_FORM_NAME, _constants.QD_RF_FIELD_AMOUNT, (0, _quickDepositLogic.formatNumber)(event.target.value, 2));
      });
    }
    return true;
  };

  var toggleAmount = function toggleAmount() {
    setShowAmountField(true);
    props.updatePlayerSetAmount(true);
    props.clearFields(_constants.QD_RF_FORM_NAME, false, false, _constants.QD_RF_FIELD_AMOUNT);
  };

  var _props$t = props.t,
      t = _props$t === undefined ? function () {
    var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return function (msg) {
      return '' + ctx + msg;
    };
  } : _props$t,
      currencyValue = props.currencyValue,
      currencyCode = props.currencyCode,
      formElementIndex = props.formElementIndex,
      amountValue = props.amountValue;


  return _react2.default.createElement(
    'div',
    { className: 'qd-amount' },
    !showAmountfield && _react2.default.createElement(
      _buttons.Button,
      {
        className: 'qd-other-amount-btn',
        tabIndex: formElementIndex,
        onClick: toggleAmount,
        outfit: 'large expanded blue-30'
      },
      t(_constants.TRANSLATION_CONTEXT)('FORM_LBL_OTHER_AMOUNT')
    ),
    showAmountfield && _react2.default.createElement(
      'div',
      { className: 'qd-amount-label' },
      t(_constants.TRANSLATION_CONTEXT)('FORM_LBL_AMOUNT')
    ),
    showAmountfield && _react2.default.createElement(_components.Amount, {
      name: _constants.QD_RF_FIELD_AMOUNT,
      amountLabel: '',
      amountValue: amountValue,
      currencyValue: currencyValue,
      normalize: _common.onlyNumbersDecimals,
      tabIndex: formElementIndex,
      onBlur: updateAmount,
      validation: [(0, _common.isRequired)(t(_constants.TRANSLATION_CONTEXT)('VAL_AMOUNT_REQUIRED')), (0, _common.number)(t(_constants.TRANSLATION_CONTEXT)('VAL_AMOUNT_NOT_NUMERIC')), (0, _common.getDepositAmountValidationI18nd)(t(_constants.TRANSLATION_CONTEXT), _quickDepositLogic.PaymentsApi.setFormDepositAmountIfValid, currencyValue, currencyCode)]
    })
  );
};